<template>
  <div class="noticeMsg">
    <div class="index-header">
      <span class="title"> <i class="el-icon-caret-right"></i>通知管理 </span>
      <span class="other more" @click="jumpMore">
        更多
        <i class="el-icon-d-arrow-right"></i>
      </span>
    </div>
    <div class="noticeMsg-main">
      <div class="son" v-for="(item, index) in data" :key="index">
        <!-- 接受类型 -->
        <template v-if="item.NoticeOption === '接收'">
          <div
            class="h1"
            @click="linkToReciverDetails(item)"
            :title="item.Title"
          >
            {{ item.Title }}
          </div>
          <div class="div-style col-33">
            通知类型:{{ msgTypes[item.MsgType] }}
          </div>
          <div class="div-style col-33">
            通知时间:{{ item.SendTime | formatDate('yyyy-MM-dd') }}
          </div>
          <div class="div-style col-33" v-if="item.MsgType !== 1">
            回复情况:{{ item.repeatInfo }}
          </div>
          <div class="div-style col-33" v-else>
            查看情况:{{ item.repeatInfo }}
          </div>
        </template>
        <!-- 发送类型 -->
        <template v-if="item.NoticeOption === '发送'">
          <div class="h1" @click="linkToDetails(item)" :title="item.Title">
            {{ item.Title }}
          </div>
          <div class="div-style col-33">
            通知类型:{{ msgTypes[item.MsgType] }}
          </div>
          <div class="div-style col-33">
            通知时间:{{ item.CreateTime | formatDate('yyyy-MM-dd') }}
          </div>
          <div class="div-style col-33" v-if="item.MsgType !== 1">
            <template v-if="item.MsgType !== 6 && item.MsgType !== 7">
              回复情况:{{ item.RepeatNum }}/{{ item.TotalReceiveNum }}
            </template>
          </div>
          <div v-else>&nbsp;</div>
          <div
            class="ub ub-ac py-progress"
            v-if="item.MsgType !== 1 && item.MsgType === 5"
          >
            <div class="ft12 footer-label">签到情况：</div>
            <div class="ub-f1">
              <el-progress
                :stroke-width="14"
                color="#409EFF"
                :show-text="true"
                :text-inside="true"
                class="col-33"
                :percentage="
                  parseInt(item.AllMemberNum) === 0
                    ? 0
                    : (
                        parseInt(item.Signed) / parseInt(item.AllMemberNum)
                      ).toFixed(2) * 100
                "
              ></el-progress>
            </div>
          </div>
          <div v-else>&nbsp;</div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import commonTitle from '@/assets/js/commonTitle.js';
import { WechatNoticeMsgController } from '@/service/WechatNoticeMsgController/WechatNoticeMsgController';
import { mapState } from 'vuex';
import { EnumController } from '@/service/EnumController/EnumController.js';

export default {
  components: {},
  props: {},
  data() {
    return {
      Position: 'running',
      data: [],
      msgTypes: {},
    };
  },
  computed: {
    ...mapState(['token', 'userInfo']),
    mainTitle: () => {
      return commonTitle;
    },
  },
  created() {
    this.enumController = new EnumController();
    this.wechatNoticeMsgController = new WechatNoticeMsgController();
    this.getEnum();
  },
  mounted() {
    this.getdata();
  },
  methods: {
    getEnum() {
      this.enumController
        .getEnum('wy.core.common.EWeChatNoticeMsgType', '')
        .then((res) => {
          for (const item of res) {
            this.msgTypes[item.value] = item.label;
          }
        });
    },
    jumpMore() {
      this.$router.push({
        path: '/noticeManage',
        query: { t: Date.now() },
      });
    },
    linkToReciverDetails(row) {
      this.$router.push({
        path: '/noticeDetailsforReciver',
        query: {
          KeyId: row.NoticeId,
          RepeatId: row.RepeatKeyId,
          noticeType: 2,
        },
      });
    },
    linkToDetails(row) {
      this.$router.push({
        path: '/noticeDetails',
        query: {
          KeyId: row.KeyId,
          RepeatId: row.RepeatId,
          noticeType: 1,
        },
      });
    },
    getdata() {
      this.wechatNoticeMsgController
        .GetNextNoticeInfo(this.token, 2)
        .then((res) => {
          this.data = res._Items;
        });
    },
  },
};
</script>
<style lang="scss">
@import './css/common.scss';
.noticeMsg {
  background-color: #fff;
  .noticeMsg-main {
    overflow: hidden;
    height: 260px;
    padding: 10px;
    display: flex;
    .son {
      padding: 0 15px;
      width: 50%;
      .h1 {
        width: 100%;
        font-size: 16px;
        font-weight: 600;
        border-left: 4px solid #0f77f2;
        padding-left: 8px;
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-bottom: 8px;
      }
      .h1:hover {
        color: #0e76f1;
      }
      .div-style {
        font-size: 14px;
        padding: 10px 0;
      }
      .py-progress {
        padding: 10px 0;
      }
    }
  }
}
</style>
